<template>
    <header class="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
        <router-link to="/" class="d-flex mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
            <img src="/img/logo_pixsmart.png" height="80" class="d-inline-block align-top" style="margin-right: 30px">
        </router-link>

        <ul class="nav nav-pills justify-content-center">
            <li class="nav-item">
                <router-link to="/demo" class="nav-link">Попробовать</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/qr_code" class="nav-link">Ввести код</router-link>
            </li>
            <!--<li class="nav-item">-->
                <!--<router-link to="/store" class="nav-link">Где купить</router-link>-->
            <!--</li>-->
            <li class="nav-item">
                <router-link to="/faq" class="nav-link">Советы</router-link>
            </li>
            <li class="nav-item">
                <router-link to="/contacts" class="nav-link">О нас</router-link>
            </li>
        </ul>
    </header>
</template>

<script>
    export default {
        name: "AppHeader"
    }
</script>

<style scoped>

</style>

